import createLazyComponent from '../LazyComponent';

const Configuration = createLazyComponent(() => import('./ConfigPage'));

export default Configuration;
